/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { ECasePriority } from '../model/models';
import { ECaseStatus } from '../model/models';
import { ECaseStatusRequest } from '../model/models';
import { EServicePlace } from '../model/models';
import { EServicePlaceRequest } from '../model/models';
import { ETypeOfDuration } from '../model/models';
import { ExportDataRequestModel } from '../model/models';
import { ExportExcelRequest } from '../model/models';
import { ExportExcelResponse } from '../model/models';
import { FilterCaseModel } from '../model/models';
import { CaseDeadlineSummary } from '../model/models';
import { ServiceProviderCaseCustomerUserProductSelect } from '../model/models';
import { ServiceProviderCaseDetails } from '../model/models';
import { ServiceProviderCaseDistanceToRepairshop } from '../model/models';
import { ServiceProviderCaseListResponse } from '../model/models';
import { ServiceProviderCaseNewUnAssignedSelect } from '../model/models';
import { ServiceProviderCaseOverView } from '../model/models';
import { ServiceProviderCaseOverViewAssignRepairer } from '../model/models';
import { ServiceProviderCaseOverViewAssignRepairshop } from '../model/models';
import { ServiceProviderCasePostPut } from '../model/models';
import { ServiceProviderCaseResponsePagingResult } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class ServiceProviderCaseService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }

    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Assign to repairer
     * @param serviceProviderCaseOverViewAssignRepairer model
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceProviderCasesAssignToRepairerPut(serviceProviderCaseOverViewAssignRepairer?: ServiceProviderCaseOverViewAssignRepairer, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public apiServiceProviderCasesAssignToRepairerPut(serviceProviderCaseOverViewAssignRepairer?: ServiceProviderCaseOverViewAssignRepairer, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public apiServiceProviderCasesAssignToRepairerPut(serviceProviderCaseOverViewAssignRepairer?: ServiceProviderCaseOverViewAssignRepairer, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public apiServiceProviderCasesAssignToRepairerPut(serviceProviderCaseOverViewAssignRepairer?: ServiceProviderCaseOverViewAssignRepairer, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<any>(`${this.configuration.basePath}/api/serviceProviderCases/assignToRepairer`,
            serviceProviderCaseOverViewAssignRepairer,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Assign to repairshop
     * @param serviceProviderCaseOverViewAssignRepairshop model
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceProviderCasesAssignToRepairshopPut(serviceProviderCaseOverViewAssignRepairshop?: ServiceProviderCaseOverViewAssignRepairshop, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public apiServiceProviderCasesAssignToRepairshopPut(serviceProviderCaseOverViewAssignRepairshop?: ServiceProviderCaseOverViewAssignRepairshop, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public apiServiceProviderCasesAssignToRepairshopPut(serviceProviderCaseOverViewAssignRepairshop?: ServiceProviderCaseOverViewAssignRepairshop, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public apiServiceProviderCasesAssignToRepairshopPut(serviceProviderCaseOverViewAssignRepairshop?: ServiceProviderCaseOverViewAssignRepairshop, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<any>(`${this.configuration.basePath}/api/serviceProviderCases/assignToRepairshop`,
            serviceProviderCaseOverViewAssignRepairshop,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves count total cases
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceProviderCasesCountTotalCasesGet(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<{ [key: string]: number; }>;
    public apiServiceProviderCasesCountTotalCasesGet(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<{ [key: string]: number; }>>;
    public apiServiceProviderCasesCountTotalCasesGet(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<{ [key: string]: number; }>>;
    public apiServiceProviderCasesCountTotalCasesGet(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<{ [key: string]: number; }>(`${this.configuration.basePath}/api/serviceProviderCases/countTotalCases`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves list customer and products belong to the customer
     * @param page 
     * @param limit 
     * @param search Must check \&quot;Send empty value\&quot; or Swagger passes a comma for empty values otherwise
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceProviderCasesCustomerUserProductSelectGet(page: number, limit: number, search: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<ServiceProviderCaseCustomerUserProductSelect>>;
    public apiServiceProviderCasesCustomerUserProductSelectGet(page: number, limit: number, search: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<ServiceProviderCaseCustomerUserProductSelect>>>;
    public apiServiceProviderCasesCustomerUserProductSelectGet(page: number, limit: number, search: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<ServiceProviderCaseCustomerUserProductSelect>>>;
    public apiServiceProviderCasesCustomerUserProductSelectGet(page: number, limit: number, search: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (page === null || page === undefined) {
            throw new Error('Required parameter page was null or undefined when calling apiServiceProviderCasesCustomerUserProductSelectGet.');
        }
        if (limit === null || limit === undefined) {
            throw new Error('Required parameter limit was null or undefined when calling apiServiceProviderCasesCustomerUserProductSelectGet.');
        }
        if (search === null || search === undefined) {
            throw new Error('Required parameter search was null or undefined when calling apiServiceProviderCasesCustomerUserProductSelectGet.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Array<ServiceProviderCaseCustomerUserProductSelect>>(`${this.configuration.basePath}/api/serviceProviderCases/customerUserProductSelect/${encodeURIComponent(String(page))}/${encodeURIComponent(String(limit))}/${encodeURIComponent(String(search))}`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves case details by id
     * @param caseId caseId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceProviderCasesDetailsByCaseIdGet(caseId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ServiceProviderCaseDetails>;
    public apiServiceProviderCasesDetailsByCaseIdGet(caseId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ServiceProviderCaseDetails>>;
    public apiServiceProviderCasesDetailsByCaseIdGet(caseId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ServiceProviderCaseDetails>>;
    public apiServiceProviderCasesDetailsByCaseIdGet(caseId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (caseId === null || caseId === undefined) {
            throw new Error('Required parameter caseId was null or undefined when calling apiServiceProviderCasesDetailsByCaseIdGet.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<ServiceProviderCaseDetails>(`${this.configuration.basePath}/api/serviceProviderCases/details/${encodeURIComponent(String(caseId))}`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Export data
     * @param accessKey 
     * @param exportDataRequestModel 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceProviderCasesExportDataPost(accessKey: string, exportDataRequestModel?: ExportDataRequestModel, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public apiServiceProviderCasesExportDataPost(accessKey: string, exportDataRequestModel?: ExportDataRequestModel, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public apiServiceProviderCasesExportDataPost(accessKey: string, exportDataRequestModel?: ExportDataRequestModel, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public apiServiceProviderCasesExportDataPost(accessKey: string, exportDataRequestModel?: ExportDataRequestModel, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        if (accessKey === null || accessKey === undefined) {
            throw new Error('Required parameter accessKey was null or undefined when calling apiServiceProviderCasesExportDataPost.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/api/serviceProviderCases/exportData/${encodeURIComponent(String(accessKey))}`,
            exportDataRequestModel,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Export excel
     * @param exportExcelRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceProviderCasesExportExcelPut(exportExcelRequest?: ExportExcelRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ExportExcelResponse>;
    public apiServiceProviderCasesExportExcelPut(exportExcelRequest?: ExportExcelRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ExportExcelResponse>>;
    public apiServiceProviderCasesExportExcelPut(exportExcelRequest?: ExportExcelRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ExportExcelResponse>>;
    public apiServiceProviderCasesExportExcelPut(exportExcelRequest?: ExportExcelRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<ExportExcelResponse>(`${this.configuration.basePath}/api/serviceProviderCases/exportExcel`,
            exportExcelRequest,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves case by filter
     * @param page 
     * @param limit 
     * @param status 
     * @param servicePlace 
     * @param repairShopId 
     * @param typeOfDuration 
     * @param orderBy 
     * @param search 
     * @param isDesc 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceProviderCasesGetByFilterGet(page: number, limit: number, status: ECaseStatusRequest, servicePlace: EServicePlaceRequest, repairShopId: number, typeOfDuration: ETypeOfDuration, orderBy: string, search?: string, isDesc?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ServiceProviderCaseListResponse>;
    public apiServiceProviderCasesGetByFilterGet(page: number, limit: number, status: ECaseStatusRequest, servicePlace: EServicePlaceRequest, repairShopId: number, typeOfDuration: ETypeOfDuration, orderBy: string, search?: string, isDesc?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ServiceProviderCaseListResponse>>;
    public apiServiceProviderCasesGetByFilterGet(page: number, limit: number, status: ECaseStatusRequest, servicePlace: EServicePlaceRequest, repairShopId: number, typeOfDuration: ETypeOfDuration, orderBy: string, search?: string, isDesc?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ServiceProviderCaseListResponse>>;
    public apiServiceProviderCasesGetByFilterGet(page: number, limit: number, status: ECaseStatusRequest, servicePlace: EServicePlaceRequest, repairShopId: number, typeOfDuration: ETypeOfDuration, orderBy: string, search?: string, isDesc?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (page === null || page === undefined) {
            throw new Error('Required parameter page was null or undefined when calling apiServiceProviderCasesGetByFilterGet.');
        }
        if (limit === null || limit === undefined) {
            throw new Error('Required parameter limit was null or undefined when calling apiServiceProviderCasesGetByFilterGet.');
        }
        if (status === null || status === undefined) {
            throw new Error('Required parameter status was null or undefined when calling apiServiceProviderCasesGetByFilterGet.');
        }
        if (servicePlace === null || servicePlace === undefined) {
            throw new Error('Required parameter servicePlace was null or undefined when calling apiServiceProviderCasesGetByFilterGet.');
        }
        if (repairShopId === null || repairShopId === undefined) {
            throw new Error('Required parameter repairShopId was null or undefined when calling apiServiceProviderCasesGetByFilterGet.');
        }
        if (typeOfDuration === null || typeOfDuration === undefined) {
            throw new Error('Required parameter typeOfDuration was null or undefined when calling apiServiceProviderCasesGetByFilterGet.');
        }
        if (orderBy === null || orderBy === undefined) {
            throw new Error('Required parameter orderBy was null or undefined when calling apiServiceProviderCasesGetByFilterGet.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (page !== undefined && page !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>page, 'Page');
        }
        if (limit !== undefined && limit !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>limit, 'Limit');
        }
        if (status !== undefined && status !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>status, 'Status');
        }
        if (servicePlace !== undefined && servicePlace !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>servicePlace, 'ServicePlace');
        }
        if (repairShopId !== undefined && repairShopId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>repairShopId, 'RepairShopId');
        }
        if (typeOfDuration !== undefined && typeOfDuration !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>typeOfDuration, 'TypeOfDuration');
        }
        if (search !== undefined && search !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>search, 'Search');
        }
        if (orderBy !== undefined && orderBy !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>orderBy, 'OrderBy');
        }
        if (isDesc !== undefined && isDesc !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>isDesc, 'IsDesc');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<ServiceProviderCaseListResponse>(`${this.configuration.basePath}/api/serviceProviderCases/getByFilter`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves List Open Case In Dashboard
     * @param filterCaseModel 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceProviderCasesListCaseDeadlineGet(filterCaseModel?: FilterCaseModel, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ServiceProviderCaseResponsePagingResult>;
    public apiServiceProviderCasesListCaseDeadlineGet(filterCaseModel?: FilterCaseModel, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ServiceProviderCaseResponsePagingResult>>;
    public apiServiceProviderCasesListCaseDeadlineGet(filterCaseModel?: FilterCaseModel, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ServiceProviderCaseResponsePagingResult>>;
    public apiServiceProviderCasesListCaseDeadlineGet(filterCaseModel?: FilterCaseModel, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<ServiceProviderCaseResponsePagingResult>(`${this.configuration.basePath}/api/serviceProviderCases/getListCaseDeadline`,
            filterCaseModel,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves unassign list cases
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceProviderCasesNewUnAssignedCaseListGet(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<ServiceProviderCaseNewUnAssignedSelect>>;
    public apiServiceProviderCasesNewUnAssignedCaseListGet(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<ServiceProviderCaseNewUnAssignedSelect>>>;
    public apiServiceProviderCasesNewUnAssignedCaseListGet(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<ServiceProviderCaseNewUnAssignedSelect>>>;
    public apiServiceProviderCasesNewUnAssignedCaseListGet(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Array<ServiceProviderCaseNewUnAssignedSelect>>(`${this.configuration.basePath}/api/serviceProviderCases/newUnAssignedCaseList`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves overview details of a specific case
     * @param caseId caseId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceProviderCasesOverViewByCaseIdGet(caseId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ServiceProviderCaseOverView>;
    public apiServiceProviderCasesOverViewByCaseIdGet(caseId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ServiceProviderCaseOverView>>;
    public apiServiceProviderCasesOverViewByCaseIdGet(caseId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ServiceProviderCaseOverView>>;
    public apiServiceProviderCasesOverViewByCaseIdGet(caseId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (caseId === null || caseId === undefined) {
            throw new Error('Required parameter caseId was null or undefined when calling apiServiceProviderCasesOverViewByCaseIdGet.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<ServiceProviderCaseOverView>(`${this.configuration.basePath}/api/serviceProviderCases/overView/${encodeURIComponent(String(caseId))}`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update overview model of an case
     * @param status 
     * @param priority 
     * @param servicePlace 
     * @param caseId 
     * @param caseCode 
     * @param paymentWaiting 
     * @param repairshopId 
     * @param address 
     * @param serviceTimeTick 
     * @param messageToRepairer 
     * @param messageToCustomer 
     * @param repairerId 
     * @param repairerConfirmed 
     * @param sendEmailToCustomer 
     * @param sendEmailToRepairer 
     * @param errorTypeId 
     * @param files 
     * @param description 
     * @param listPhoto 
     * @param sendNotificationToCustomer 
     * @param newFiles 
     * @param solution 
     * @param paymentInWarehouse 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceProviderCasesOverviewModelPut(status: ECaseStatus, priority: ECasePriority, servicePlace: EServicePlace, caseId?: number, caseCode?: string, paymentWaiting?: boolean, repairshopId?: number, address?: string, serviceTimeTick?: number, messageToRepairer?: Array<string>, messageToCustomer?: Array<string>, repairerId?: string, repairerConfirmed?: boolean, sendEmailToCustomer?: boolean, sendEmailToRepairer?: boolean, errorTypeId?: number, files?: Array<string>, description?: string, listPhoto?: Array<string>, sendNotificationToCustomer?: boolean, newFiles?: Array<Blob>, solution?: string, paymentInWarehouse?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public apiServiceProviderCasesOverviewModelPut(status: ECaseStatus, priority: ECasePriority, servicePlace: EServicePlace, caseId?: number, caseCode?: string, paymentWaiting?: boolean, repairshopId?: number, address?: string, serviceTimeTick?: number, messageToRepairer?: Array<string>, messageToCustomer?: Array<string>, repairerId?: string, repairerConfirmed?: boolean, sendEmailToCustomer?: boolean, sendEmailToRepairer?: boolean, errorTypeId?: number, files?: Array<string>, description?: string, listPhoto?: Array<string>, sendNotificationToCustomer?: boolean, newFiles?: Array<Blob>, solution?: string, paymentInWarehouse?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public apiServiceProviderCasesOverviewModelPut(status: ECaseStatus, priority: ECasePriority, servicePlace: EServicePlace, caseId?: number, caseCode?: string, paymentWaiting?: boolean, repairshopId?: number, address?: string, serviceTimeTick?: number, messageToRepairer?: Array<string>, messageToCustomer?: Array<string>, repairerId?: string, repairerConfirmed?: boolean, sendEmailToCustomer?: boolean, sendEmailToRepairer?: boolean, errorTypeId?: number, files?: Array<string>, description?: string, listPhoto?: Array<string>, sendNotificationToCustomer?: boolean, newFiles?: Array<Blob>, solution?: string, paymentInWarehouse?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public apiServiceProviderCasesOverviewModelPut(status: ECaseStatus, priority: ECasePriority, servicePlace: EServicePlace, caseId?: number, caseCode?: string, paymentWaiting?: boolean, repairshopId?: number, address?: string, serviceTimeTick?: number, messageToRepairer?: Array<string>, messageToCustomer?: Array<string>, repairerId?: string, repairerConfirmed?: boolean, sendEmailToCustomer?: boolean, sendEmailToRepairer?: boolean, errorTypeId?: number, files?: Array<string>, description?: string, listPhoto?: Array<string>, sendNotificationToCustomer?: boolean, newFiles?: Array<Blob>, solution?: string, paymentInWarehouse?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        if (status === null || status === undefined) {
            throw new Error('Required parameter status was null or undefined when calling apiServiceProviderCasesOverviewModelPut.');
        }
        if (priority === null || priority === undefined) {
            throw new Error('Required parameter priority was null or undefined when calling apiServiceProviderCasesOverviewModelPut.');
        }
        if (servicePlace === null || servicePlace === undefined) {
            throw new Error('Required parameter servicePlace was null or undefined when calling apiServiceProviderCasesOverviewModelPut.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: this.encoder});
        }

        if (caseId !== undefined) {
            formParams = formParams.append('CaseId', <any>caseId) as any || formParams;
        }
        if (caseCode !== undefined) {
            formParams = formParams.append('CaseCode', <any>caseCode) as any || formParams;
        }
        if (status !== undefined) {
            formParams = formParams.append('Status', <any>status) as any || formParams;
        }
        if (paymentWaiting !== undefined) {
            formParams = formParams.append('PaymentWaiting', <any>paymentWaiting) as any || formParams;
        }
        if (priority !== undefined) {
            formParams = formParams.append('Priority', <any>priority) as any || formParams;
        }
        if (repairshopId !== undefined) {
            formParams = formParams.append('RepairshopId', <any>repairshopId) as any || formParams;
        }
        if (servicePlace !== undefined) {
            formParams = formParams.append('ServicePlace', <any>servicePlace) as any || formParams;
        }
        if (address !== undefined) {
            formParams = formParams.append('Address', <any>address) as any || formParams;
        }
        if (serviceTimeTick !== undefined) {
            formParams = formParams.append('ServiceTimeTick', <any>serviceTimeTick) as any || formParams;
        }
        if (messageToRepairer) {
            if (useForm) {
                messageToRepairer.forEach((element) => {
                    formParams = formParams.append('MessageToRepairer', <any>element) as any || formParams;
            })
            } else {
                formParams = formParams.append('MessageToRepairer', messageToRepairer.join(COLLECTION_FORMATS['csv'])) as any || formParams;
            }
        }
        if (messageToCustomer) {
            if (useForm) {
                messageToCustomer.forEach((element) => {
                    formParams = formParams.append('MessageToCustomer', <any>element) as any || formParams;
            })
            } else {
                formParams = formParams.append('MessageToCustomer', messageToCustomer.join(COLLECTION_FORMATS['csv'])) as any || formParams;
            }
        }
        if (repairerId !== undefined) {
            formParams = formParams.append('RepairerId', <any>repairerId) as any || formParams;
        }
        if (repairerConfirmed !== undefined) {
            formParams = formParams.append('RepairerConfirmed', <any>repairerConfirmed) as any || formParams;
        }
        if (sendEmailToCustomer !== undefined) {
            formParams = formParams.append('SendEmailToCustomer', <any>sendEmailToCustomer) as any || formParams;
        }
        if (sendEmailToRepairer !== undefined) {
            formParams = formParams.append('SendEmailToRepairer', <any>sendEmailToRepairer) as any || formParams;
        }
        if (errorTypeId !== undefined) {
            formParams = formParams.append('ErrorTypeId', <any>errorTypeId) as any || formParams;
        }
        if (files) {
            if (useForm) {
                files.forEach((element) => {
                    formParams = formParams.append('Files', <any>element) as any || formParams;
            })
            } else {
                formParams = formParams.append('Files', files.join(COLLECTION_FORMATS['csv'])) as any || formParams;
            }
        }
        if (description !== undefined) {
            formParams = formParams.append('Description', <any>description) as any || formParams;
        }
        if (listPhoto) {
            if (useForm) {
                listPhoto.forEach((element) => {
                    formParams = formParams.append('ListPhoto', <any>element) as any || formParams;
            })
            } else {
                formParams = formParams.append('ListPhoto', listPhoto.join(COLLECTION_FORMATS['csv'])) as any || formParams;
            }
        }
        if (sendNotificationToCustomer !== undefined) {
            formParams = formParams.append('SendNotificationToCustomer', <any>sendNotificationToCustomer) as any || formParams;
        }
        if (newFiles) {
            if (useForm) {
                newFiles.forEach((element) => {
                    formParams = formParams.append('NewFiles', <any>element) as any || formParams;
            })
            } else {
                formParams = formParams.append('NewFiles', newFiles.join(COLLECTION_FORMATS['csv'])) as any || formParams;
            }
        }
        if (solution !== undefined) {
            formParams = formParams.append('Solution', <any>solution) as any || formParams;
        }
        if (paymentInWarehouse !== undefined) {
            formParams = formParams.append('PaymentInWarehouse', <any>paymentInWarehouse) as any || formParams;
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<any>(`${this.configuration.basePath}/api/serviceProviderCases/overviewModel`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create new case from SP
     * @param serviceProviderCasePostPut case info
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceProviderCasesPost(serviceProviderCasePostPut?: ServiceProviderCasePostPut, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public apiServiceProviderCasesPost(serviceProviderCasePostPut?: ServiceProviderCasePostPut, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public apiServiceProviderCasesPost(serviceProviderCasePostPut?: ServiceProviderCasePostPut, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public apiServiceProviderCasesPost(serviceProviderCasePostPut?: ServiceProviderCasePostPut, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/api/serviceProviderCases`,
            serviceProviderCasePostPut,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves repairshops include distance to the case
     * @param caseId caseId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceProviderCasesRepairshopDistanceByCaseIdGet(caseId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<ServiceProviderCaseDistanceToRepairshop>>;
    public apiServiceProviderCasesRepairshopDistanceByCaseIdGet(caseId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<ServiceProviderCaseDistanceToRepairshop>>>;
    public apiServiceProviderCasesRepairshopDistanceByCaseIdGet(caseId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<ServiceProviderCaseDistanceToRepairshop>>>;
    public apiServiceProviderCasesRepairshopDistanceByCaseIdGet(caseId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (caseId === null || caseId === undefined) {
            throw new Error('Required parameter caseId was null or undefined when calling apiServiceProviderCasesRepairshopDistanceByCaseIdGet.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Array<ServiceProviderCaseDistanceToRepairshop>>(`${this.configuration.basePath}/api/serviceProviderCases/repairshopDistance/${encodeURIComponent(String(caseId))}`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves repairshops include distance to customer
     * @param userId Must check \&quot;Send empty value\&quot; or Swagger passes a comma for empty values otherwise
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceProviderCasesRepairshopDistanceToCustomerByCustomerIdGet(userId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<ServiceProviderCaseDistanceToRepairshop>>;
    public apiServiceProviderCasesRepairshopDistanceToCustomerByCustomerIdGet(userId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<ServiceProviderCaseDistanceToRepairshop>>>;
    public apiServiceProviderCasesRepairshopDistanceToCustomerByCustomerIdGet(userId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<ServiceProviderCaseDistanceToRepairshop>>>;
    public apiServiceProviderCasesRepairshopDistanceToCustomerByCustomerIdGet(userId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling apiServiceProviderCasesRepairshopDistanceToCustomerByCustomerIdGet.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Array<ServiceProviderCaseDistanceToRepairshop>>(`${this.configuration.basePath}/api/serviceProviderCases/repairshopDistanceToCustomer/${encodeURIComponent(String(userId))}`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }


    public apiServiceProviderCasesCaseDeadlineSummaryPost(filterCaseModel?: FilterCaseModel): Observable<CaseDeadlineSummary> {
        let headers = this.defaultHeaders;
        const credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }
        headers = headers.set('Accept', 'application/json');
        headers = headers.set('Content-Type', 'application/json');

        return this.httpClient.post<CaseDeadlineSummary>(`${this.configuration.basePath}/api/ServiceProviderCases/getCaseDeadlineSummary`,
            filterCaseModel,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
}
